<template>
  <HomeLayout>
    <b-row>
      <b-col cols="4" class="home-container-header-corp-logo">
        <b-img
          src="https://cdn.trailfinders.com/k9os0u3ty0_tf_corporate-logo.png"
          fluid
          alt="Corporate"
          class="corp-header-image"
        />
      </b-col>
      <b-col cols="8" class="home-container-header-corp-buttons">
        <button class="logout-btn-corp" @click="logOutClick">
          <span>Logout</span>
        </button>
      </b-col>
    </b-row>

    <b-row class="column-border-container">
      <b-col class="column-border col-lg-4 card-col col-md-12 col-sm-12 col-12">
        <a
          class="vtd-card vtd-animate-shake"
          @click.prevent="() => {$refs.AllBookingsRef.show()}"
        >
          <div class="vtd-home-block">
            <h6 class="vtd-card-title d-none d-lg-block">01</h6>
            <h5>ALL BOOKINGS</h5>
            <div class="vtd-text-center">
              <i class="material-icons vtd-icon-7"></i>
            </div>
            <p class="pt-3 d-none d-lg-block">View all company bookings with easy access to invoicing and receipts.</p>
          </div>
          <div class="vtd-card-footer vtd-text-center d-none d-lg-block">
            <p class="vtd-home-btn pl-2">View Now</p>
          </div>
        </a>
      </b-col>

      <b-col
        class="column-border col-lg-4 card-col col-md-12 col-sm-12 col-12"
      >
        <router-link
          to="/profile-corp"
          class="vtd-card vtd-animate-shake"
        >
          <div class="vtd-home-block">
            <h6 class="vtd-card-title d-none d-lg-block">
              02
            </h6>
            <h5>MY COMPANY PROFILE</h5>
            <div class="vtd-text-center">
              <i class="material-icons vtd-icon-7">&#xE8A3;</i>
            </div>
            <p class="pt-3 d-none d-lg-block">
              View/Edit your contact details.
            </p>
          </div>
          <div class="vtd-card-footer vtd-text-center d-none d-lg-block">
            <p class="vtd-home-btn pl-2">
              View and Edit
            </p>
          </div>
        </router-link>
      </b-col>

      <b-col
        class="column-border col-lg-4 card-col col-md-12 col-sm-12 col-12"
      >
        <a
          class="vtd-card vtd-animate-shake"
          @click.prevent="() => {$refs.YourContactRef.show()}"
        >
          <div class="vtd-home-block">
            <h6 class="vtd-card-title d-none d-lg-block">
              03
            </h6>
            <h5> YOUR CONTACT AT TRAILFINDERS</h5>
            <div class="vtd-text-center">
              <b-img
                src="https://www.trailfinders.com/codesource/corporate/corp-contact.png"
                fluid
                alt="Contact"
              />
            </div>
            <p class="vtd-card-text vtd-hidden-md-down d-none d-lg-block">
              Understand more about Trailfinders Corporate Travel, who we are and what we can offer.
            </p>
          </div>
          <div class="vtd-card-footer vtd-text-center d-none d-lg-block">
            <p class="vtd-home-btn pl-2">
              Read Now
            </p>
          </div>
        </a>
      </b-col>
    </b-row>
    <AllBookings ref="AllBookingsRef" />
    <YourContact ref="YourContactRef" />
  </HomeLayout>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import HomeLayout from "@/partials/home-layout/corporate"
import AllBookings from "@/modules/all-bookings"
import YourContact from "@/modules/corporate/your-contact"

export default {
  components: {
    HomeLayout,
    AllBookings,
    YourContact
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      booking: 'booking/getBooking',
      fil: 'booking/getFil',
      firstFlightItineraryItem: 'booking/getFirstFlightItineraryItem',
      userData: 'auth/getUserData'
    })
  },
  async created() {
    const loginRes = await this.loginOnStart({
      username: this.$route.params.surname,
      bookingNumber: this.$route.params.bookingNumber,
      source: this.$route.params.source
    })
    if (!loginRes) {
      this.$router.push('/login')
    }
  },
  methods: {
    ...mapActions({
      loginOnStart: 'auth/loginBookingNumberOnStartAction',
      logout: 'auth/logoutAction'
    }),
    logOutClick() {
      this.logout()
    }
  }
}
</script>

<style>
  @import './styles.scss';
</style>
